/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SimulationTaskListApiResponse } from '../../models/simulation-task-list-api-response';

export interface SimulationTasksGet$Params {
  page?: number;
  pageSize?: number;
}

export function simulationTasksGet(http: HttpClient, rootUrl: string, params?: SimulationTasksGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SimulationTaskListApiResponse>> {
  const rb = new RequestBuilder(rootUrl, simulationTasksGet.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SimulationTaskListApiResponse>;
    })
  );
}

simulationTasksGet.PATH = '/simulation-tasks';
